import { combineReducers } from "redux";
import {
  USER_GET_LOADING,
  USER_GET_ERROR,
  USER_GET_SUCCESS,
  USER_VIEW_ERROR,
  USER_VIEW_LOADING,
  USER_VIEW_SUCCESS,
  USER_ADD_ERROR,
  USER_ADD_LOADING,
  USER_ADD_SUCCESS,
  USER_DELETE_ERROR,
  USER_DELETE_LOADING,
  USER_DELETE_SUCCESS,
  USER_OPERATOR_PUSAT_ERROR,
  USER_OPERATOR_PUSAT_LOADING,
  USER_OPERATOR_PUSAT_SUCCESS,
  USER_PELINDO_LOADING,
  USER_PELINDO_ERROR,
  USER_PELINDO_SUCCESS,
  USER_UPT_LOADING,
  USER_UPT_ERROR,
  USER_UPT_SUCCESS,
} from "../actions/constant";

const userOperatorPusatError = (state = false, action) => {
  switch (action.type) {
    case USER_OPERATOR_PUSAT_ERROR:
      return action.userOperatorPusatError;
    default:
      return state;
  }
};

const userOperatorPusatLoading = (state = false, action) => {
  switch (action.type) {
    case USER_OPERATOR_PUSAT_LOADING:
      return action.userOperatorPusatLoading;
    default:
      return state;
  }
};

const userOperatorPusatSuccess = (state = false, action) => {
  switch (action.type) {
    case USER_OPERATOR_PUSAT_SUCCESS:
      return action.userOperatorPusatSuccess;
    default:
      return state;
  }
};

const userOperatorPusat = (state = [], action) => {
  switch (action.type) {
    case USER_OPERATOR_PUSAT_SUCCESS:
      return action.userOperatorPusat;
    default:
      return state;
  }
};

const userGetError = (state = false, action) => {
  switch (action.type) {
    case USER_GET_ERROR:
      return action.userGetError;
    default:
      return state;
  }
};

const userGetLoading = (state = false, action) => {
  switch (action.type) {
    case USER_GET_LOADING:
      return action.userGetLoading;
    default:
      return state;
  }
};

const userGetSuccess = (state = false, action) => {
  switch (action.type) {
    case USER_GET_SUCCESS:
      return action.userGetSuccess;
    default:
      return state;
  }
};

const users = (state = [], action) => {
  switch (action.type) {
    case USER_GET_SUCCESS:
      return action.users;
    default:
      return state;
  }
};

const userViewLoading = (state = false, action) => {
  switch (action.type) {
    case USER_VIEW_LOADING:
      return action.userViewLoading;
    default:
      return state;
  }
};

const userViewError = (state = false, action) => {
  switch (action.type) {
    case USER_VIEW_ERROR:
      return action.userViewError;
    default:
      return state;
  }
};

const userViewSuccess = (state = false, action) => {
  switch (action.type) {
    case USER_VIEW_SUCCESS:
      return action.userViewSuccess;
    default:
      return state;
  }
};

const user = (state = [], action) => {
  switch (action.type) {
    case USER_VIEW_SUCCESS:
      return action.user;
    default:
      return state;
  }
};

const userAddError = (state = false, action) => {
  switch (action.type) {
    case USER_ADD_ERROR:
      return action.userAddError;
    default:
      return state;
  }
};

const userAddLoading = (state = false, action) => {
  switch (action.type) {
    case USER_ADD_LOADING:
      return action.userAddLoading;
    default:
      return state;
  }
};

const userAddSuccess = (state = false, action) => {
  switch (action.type) {
    case USER_ADD_SUCCESS:
      return action.userAddSuccess;
    default:
      return state;
  }
};

const userDeleteError = (state = false, action) => {
  switch (action.type) {
    case USER_DELETE_ERROR:
      return action.userDeleteError;
    default:
      return state;
  }
};

const userDeleteLoading = (state = false, action) => {
  switch (action.type) {
    case USER_DELETE_LOADING:
      return action.userDeleteLoading;
    default:
      return state;
  }
};

const userDeleteSuccess = (state = false, action) => {
  switch (action.type) {
    case USER_DELETE_SUCCESS:
      return action.userDeleteSuccess;
    default:
      return state;
  }
};

const userPelindoLoading = (state = false, action) => {
  switch (action.type) {
    case USER_PELINDO_LOADING:
      return action.userPelindoLoading;
    default:
      return state;
  }
};

const userPelindoError = (state = false, action) => {
  switch (action.type) {
    case USER_PELINDO_ERROR:
      return action.userPelindoError;
    default:
      return state;
  }
};

const userPelindoSuccess = (state = false, action) => {
  switch (action.type) {
    case USER_PELINDO_SUCCESS:
      return action.userPelindoSuccess;
    default:
      return state;
  }
};

const userPelindo = (state = [], action) => {
  switch (action.type) {
    case USER_PELINDO_SUCCESS:
      return action.userPelindo;
    default:
      return state;
  }
};

const userUptLoading = (state = false, action) => {
  switch (action.type) {
    case USER_UPT_LOADING:
      return action.userUptLoading;
    default:
      return state;
  }
};

const userUptError = (state = false, action) => {
  switch (action.type) {
    case USER_UPT_ERROR:
      return action.userUptError;
    default:
      return state;
  }
};

const userUptSuccess = (state = false, action) => {
  switch (action.type) {
    case USER_UPT_SUCCESS:
      return action.userUptSuccess;
    default:
      return state;
  }
};

const userUpt = (state = [], action) => {
  switch (action.type) {
    case USER_UPT_SUCCESS:
      return action.userUpt;
    default:
      return state;
  }
};

const userReducer = combineReducers({
  userGetError,
  userGetLoading,
  userGetSuccess,
  users,

  userViewLoading,
  userViewError,
  userViewSuccess,
  user,

  userAddError,
  userAddLoading,
  userAddSuccess,

  userDeleteError,
  userDeleteLoading,
  userDeleteSuccess,

  userOperatorPusatLoading,
  userOperatorPusatSuccess,
  userOperatorPusatError,
  userOperatorPusat,

  userPelindoLoading,
  userPelindoSuccess,
  userPelindoError,
  userPelindo,

  userUptError,
  userUptLoading,
  userUptSuccess,
  userUpt,
});

export default userReducer;
